/* eslint-disable no-unused-vars */

import { useRef, Fragment, useCallback } from 'react';
import { Formik, Field } from 'formik';
import styled, { withTheme } from 'styled-components';
import * as yup from 'yup';

import {
    FovInput,
    FovFieldError,
    Tags,
    VerticalSpacer,
    FovButton,
    H5,
} from 'components';

import { AVAILABILITY_FORMATS } from 'utils';

// TODO: Use update creator admin action
// import { updateTeamIdAdmin } from 'store/actions/admin';

import { TitleContainer } from './styles';
import { updateCreatorIdAdmin } from 'store/actions/adminActions/creators';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';

const ButtonContainer = styled('div')`
    display: inline-flex;
    width: 100%;
    max-width: 25rem;
`;

const InputContainer = styled('div')`
    max-width: 25rem;
`;

export const Settings = withTheme(props => {
    const { creator } = props;
    const dispatch = useDispatch();
    const formikRef = useRef();

    const [ cookies ] = useCookies([ 'userAuth' ]);
    const token = cookies.archvision_token;

    const subscriptionFormats = creator?.allowed_subscription_formats?.join(',') || '';
    const purchaseFormats = creator?.allowed_purchase_formats?.join(',') || '';
    const displayName = creator.display_name;

    const setRef = form => {
        if (!formikRef.current) {
            formikRef.current = form;
        }
    };

    const handleSubmit = useCallback(args => {
        const { values, setSubmitting } = args;
        const { purchaseFormats, subscriptionFormats } = values;
        const subscriptionArr = subscriptionFormats.split(',');
        const purchaseArr = purchaseFormats.split(',');

        const creatorData = {
            displayName,
            allowedSubscriptionFormats: subscriptionArr,
            allowedPurchaseFormats: purchaseArr,
        };

        dispatch(updateCreatorIdAdmin(token, creator.creator_id, creatorData))
             .finally(setSubmitting(false));
    }, [ ]);

    const defaults = {
        displayName: displayName || '',
        subscriptionFormats: subscriptionFormats || '',
        purchaseFormats: purchaseFormats,
    };

    const schema = yup.object().shape({
        displayName: yup.string().required('A display name is required.'),
        subscriptionFormats: yup.string().required('At least one format is required.')
            .test('is-valid',
                `Each subscription format must be in ${AVAILABILITY_FORMATS.join (', ')}`,
                value => value?.split?.(',').every(format => AVAILABILITY_FORMATS.includes(format)),
            ),
        purchaseFormats: yup.string().required('At least one format is required.')
            .test('is-valid',
                `Each purchase format must be in ${AVAILABILITY_FORMATS.join (', ')}`,
                value => value?.split?.(',').every(format => AVAILABILITY_FORMATS.includes(format)),
            ),
    });


    return (
        <Fragment>
            <TitleContainer>
                <H5>Settings (WIP)</H5>
            </TitleContainer>
            <VerticalSpacer size={7} />
            <Formik
                initialValues={defaults}
                validationSchema={schema}
                onSubmit={(values, handlers) => {
                    const { setSubmitting } = handlers;
                    handleSubmit({ values, setSubmitting });
                }}
                validateOnChange={true}
            >
            {form => (
                <Fragment>
                {setRef(form)}
                Display Name
                <Field type='text' name='displayName'>
                {data => (
                    <InputContainer>
                        <FovInput
                            value={data.field.value}
                            placeholder={displayName}
                            {...data.field}
                            onChange={e => {
                                const newVal = e.target.value;
                                form.setFieldValue(data.field.name, newVal);
                            }}
                        />
                    </InputContainer>
                )}
                </Field>
                <FovFieldError name='displayName' />

                Subscription Formats
                <VerticalSpacer size={10} />

                <Field type='input' name='subscriptionFormats'>
                {data => (
                    <Tags
                        values={data.field.value ? data.field.value : []}
                        newTagText='Add format'
                        onChange={(e, domains) => {
                            form.setFieldValue(data.field.name, domains);
                        }}
                    />
                )}
                </Field>
                <FovFieldError name='subscriptionFormats' />

                Purchase Formats
                <VerticalSpacer size={10} />

                <Field type='input' name='purchaseFormats'>
                {data => (
                    <Tags
                        values={data.field.value ? data.field.value : []}
                        newTagText='Add format'
                        onChange={(e, domains) => {
                            form.setFieldValue(data.field.name, domains);
                        }}
                    />
                )}
                </Field>
                <FovFieldError name='purchaseFormats' />
                <ButtonContainer>
                    <FovButton
                        type='submit'
                        disabled={form.isSubmitting}
                        onClick={form.handleSubmit}
                    >
                    Save Settings
                    </FovButton>
                </ButtonContainer>


                </Fragment>
            )}
            </Formik>
        </Fragment>
    );
});
